export enum CourseType {
    Regular='Regular',
    AsRequired='AsRequired',
    ShortCourse='ShortCourse'
}